import type { CmlContent } from '__generated__/graphql-types';

import _t from 'i18n!nls/xdp';

const getSpecializationDescription = (cmlDescription?: CmlContent | null, projectsOverview?: CmlContent | null) => {
  const cmlProjectsOverviewTitle = `<text>${_t('Applied Learning Project')}</text>`;
  const htmlProjectsOverviewTitle = `<p>${_t('Applied Learning Project')}</p>`;

  // We want to combine the projectsOverview and cmlDescription if both are present.
  if (projectsOverview && cmlDescription) {
    return {
      ...cmlDescription,
      cmlValue:
        cmlDescription.cmlValue.split('</co-content>')[0] +
        cmlProjectsOverviewTitle +
        projectsOverview.cmlValue.split('<co-content>')[1],
      htmlWithMetadata: {
        ...cmlDescription.htmlWithMetadata,
        html: cmlDescription.htmlWithMetadata.html + htmlProjectsOverviewTitle + projectsOverview.htmlWithMetadata.html,
        metadata: {
          ...cmlDescription.htmlWithMetadata.metadata,
          hasAssetBlock:
            cmlDescription.htmlWithMetadata.metadata.hasAssetBlock ||
            projectsOverview.htmlWithMetadata.metadata.hasAssetBlock,
          hasMath:
            cmlDescription.htmlWithMetadata.metadata.hasMath || projectsOverview.htmlWithMetadata.metadata.hasMath,
          hasCodeBlock:
            cmlDescription.htmlWithMetadata.metadata.hasCodeBlock ||
            projectsOverview.htmlWithMetadata.metadata.hasCodeBlock,
          isPlainText:
            cmlDescription.htmlWithMetadata.metadata.isPlainText ||
            projectsOverview.htmlWithMetadata.metadata.isPlainText,
        },
      },
    } as CmlContent;
  } else {
    return cmlDescription;
  }
};

export default getSpecializationDescription;
